import React from "react";
import { connect } from "react-redux";
import Toolbar from "./Toolbar";
import { exportDrawing,previewDrawing,saveDrawing,textSelected, setProjectError, inputDqcData, orderProfileType} from "../../actions/wizard";
class LowerRailComponent extends React.Component<any, any>{
    constructor(props) {
      super(props)
    }

    exportFunction = () =>{
        // const bothOptionsSelected = this.props.pages?.filter(obj => obj?.reviewed && obj?.isOptional);
        // if(bothOptionsSelected.length) {
        //     this.props.setProjectError({ error: bothOptionsSelected });
        //     return;
        // }
        if(['dc', 'designcafe'].includes(this.props.orderProfileType?.toLowerCase())) {
            this.props.inputDqcData({isDqcDataPresent:true,dqcUpdateMode:false,dqcAddMode:false});
        }
        this.props.exportDrawing({projectData: this.props.projectData})
    } 


    render(){
        const {previewMode,setDrawingStatus} =this.props;
        const previewClass =previewMode ==='enabled'?'activePreview right':''


        return(
            <div className={'lowerRail'}>
                <div className={'left'}>
                    <Toolbar/>
                </div>
               <div className={'right'}>
                   <div className={previewClass} onClick={()=>{(setDrawingStatus && setDrawingStatus!=='pending') &&
                   this.props.previewDrawing((previewMode==='disabled' || !previewMode)?'enabled':'disabled')}}>
                       Preview
                       {/*<Eye/>*/}
                   </div>
                   <div onClick={()=>{setDrawingStatus && setDrawingStatus!=='pending' &&
                   this.exportFunction()}} className={'export'}>
                       Export
                   </div>
                </div>
            </div>
        )
    }
}
export default connect(
    (state: any) => ({
        previewMode:state.wizard.previewMode,
        projectData: state.wizard.projectData,
        setDrawingStatus: state.wizard.setDrawingStatus,
        isDqcDataPresent: state.wizard.isDqcDataPresent,
        isTextSelected:state.wizard.isTextSelected,
        fabricInstance:state.wizard.fabricInstance,
        pages: state.wizard.pages,
        orderProfileType: state.wizard.orderProfileType,
    }),
    {
        exportDrawing,
        previewDrawing,
        saveDrawing,
        textSelected,
        setProjectError,
        inputDqcData
    }
)(LowerRailComponent);